import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import AssetBrandTypeService from "services/Setup/Organization/assetBrandTypeService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  AssetBrandTypeList: {},
  refreshList: false,
  AssetBrandTypeApprovalList: {},
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
};

export const postAssetBrandType = createAsyncThunk(
  "assetBrandType/postAssetBrandType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetBrandTypeService.postAssetBrandType(data);
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getAssetBrandTypeList = createAsyncThunk(
  "assetBrandType/getAssetBrandTypeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await AssetBrandTypeService.getAssetBrandTypeList(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getAssetBrandTypeApprovalList = createAsyncThunk(
  "assetBrandType/getAssetBrandTypeApprovalList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await AssetBrandTypeService.getAssetBrandTypeApprovalList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putAssetBrandTypeApproval = createAsyncThunk(
  "assetBrandType/putAssetBrandTypeApproval",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetBrandTypeService.putAssetBrandTypeApproval(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putAssetBrandTypeRequest = createAsyncThunk(
  "assetBrandType/putAssetBrandTypeRequest",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetBrandTypeService.putAssetBrandTypeRequest(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          // message: "Error",
          // description: "Unexpected response!",
          message: response.status,
          description: response.statusText,
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getAssetBrandTypeDetail = createAsyncThunk(
  "assetBrandType/getAssetBrandTypeDetail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetBrandTypeService.getAssetBrandTypeDetail(
        data
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateAssetBrandType = createAsyncThunk(
  "assetBrandType/updateAssetBrandType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetBrandTypeService.updateAssetBrandType(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteAssetBrandType = createAsyncThunk(
  "assetBrandType/deleteAssetBrandType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetBrandTypeService.deleteAssetBrandType(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const AssetBrandTypeSlice = createSlice({
  name: "assetBrandType",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder

      //post
      .addCase(postAssetBrandType.pending, (state) => {
        state.loading = true;
      })
      .addCase(postAssetBrandType.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
      })
      .addCase(postAssetBrandType.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list
      .addCase(getAssetBrandTypeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAssetBrandTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.AssetBrandTypeList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getAssetBrandTypeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //AssetBrandType approval list
      .addCase(getAssetBrandTypeApprovalList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAssetBrandTypeApprovalList.fulfilled, (state, action) => {
        state.loading = false;
        state.AssetBrandTypeApprovalList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getAssetBrandTypeApprovalList.rejected, (state, action) => {
        state.loading = false;
        state.AssetBrandTypeApprovalList = action.payload;
      })

      //AssetBrandType approval approve
      .addCase(putAssetBrandTypeApproval.pending, (state) => {
        state.loading = true;
        // state.redirect = "";
      })
      .addCase(putAssetBrandTypeApproval.fulfilled, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(putAssetBrandTypeApproval.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //AssetBrandType approval request
      .addCase(putAssetBrandTypeRequest.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(putAssetBrandTypeRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(putAssetBrandTypeRequest.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //detail
      .addCase(getAssetBrandTypeDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAssetBrandTypeDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(getAssetBrandTypeDetail.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //update
      .addCase(updateAssetBrandType.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateAssetBrandType.fulfilled, (state, action) => {
        state.loading = false;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updateAssetBrandType.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete
      .addCase(deleteAssetBrandType.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAssetBrandType.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteAssetBrandType.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  //    update,
  showNotification,
  hideNotification,
  showLoading,
} = AssetBrandTypeSlice.actions;

export default AssetBrandTypeSlice.reducer;
